import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=4965962a&"
import script from "./PricingCard.vue?vue&type=script&lang=js&"
export * from "./PricingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4965962a')) {
      api.createRecord('4965962a', component.options)
    } else {
      api.reload('4965962a', component.options)
    }
    module.hot.accept("./PricingCard.vue?vue&type=template&id=4965962a&", function () {
      api.rerender('4965962a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/PricingCard.vue"
export default component.exports